import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";

import { DeeplinkNoteComponent } from "./deeplink-note/deeplink-note.component";
import { DeeplinkSideComponent } from "./deeplink-side/deeplink-side.component";

const routes: Routes = [
    {
        path: "sider/noter/:noteid",
        component: DeeplinkNoteComponent
    },
    {
        path: "sider/:side/ejendomme/:ejendomnr/installationer/:installationnr",
        component: DeeplinkSideComponent
    },
    {
        path: "sider/:side/ejendomme/:ejendomnr",
        component: DeeplinkSideComponent
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class DeeplinkRoutingModule {}
